export default __webpack_public_path__ + "static/media/FeedbackCompass.14f9823a592a7bfd06bdd9374ad38437.webp";